<template>
    <div id="recoveryProfit">
        <el-col style="width:100%">
            <el-form ref="searchForm" :model="searchForm" :inline="true" label-width="100px" :label-position="labelPosition">
                <el-form-item style="margin-bottom: 15px;">
                    <el-input clearable clearable v-model.trim="searchForm.modelName" placeholder="请输入型号名称" style="width:200px"></el-input>
                </el-form-item>
                <el-form-item style="margin-bottom: 15px;">
                    <el-input clearable clearable v-model.trim="searchForm.customerPhone" placeholder="请输手机号" style="width:200px"></el-input>
                </el-form-item>
                <el-form-item style="margin-bottom: 15px;">
                    <el-input clearable v-model="searchForm.shopAccount" placeholder="请输入店铺账号" style="width:200px"></el-input>
                </el-form-item>
                <el-form-item style="margin-bottom: 15px;">
                    <el-input clearable v-model="searchForm.shopName" placeholder="请输入店铺名称" style="width:200px"></el-input>
                </el-form-item>
                <el-date-picker
                        style="width: 240px;margin-bottom:10px;"
                        v-model="valueTime1"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        type="daterange"
                        range-separator="-"
                        :default-time="['00:00:00', '23:59:59']"
                        start-placeholder="创建开始"
                        end-placeholder="创建结束">
                    </el-date-picker>
                <el-form-item style="margin-bottom: 15px;">
                    <el-button type="primary" size="small" @click="SubmitSearch('searchForm')">查询</el-button>
                    <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button>
                </el-form-item>
                <el-form-item class="fr">
                    <el-col style="width:520px;text-align:right">
                        <!-- <el-button v-if="basicsAuth.insertMaterialClassification" size="medium" type="success" @click="createClass">新建分类</el-button> -->
                        <el-button type="success" size="medium" @click="getrecyclingExports()">导出</el-button>
                        <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 30px;" @click="refresh()"></i>
                    </el-col>
                </el-form-item>
            </el-form>
        </el-col>
        <el-card class="box-card">
            <el-table
                :data="returnData"
                border
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%">
                <el-table-column
                    align="center"
                    prop="id"
                    label="id">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="modelName"
                    label="型号名称">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="customerPhone"
                    label="手机号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="shopAccount"
                    label="店铺账号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="shopName"
                    label="店铺名称">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="defectName"
                    label="选项内容"
                    width="700">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="originalPrice"
                    label="原始价格">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="price"
                    label="价格">
                </el-table-column>
                 <el-table-column
                    align="center"
                    width="160"
                    prop="created"
                    sortable
                    label="创建时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.created | date}} </span>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[30, 50, 100]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next,jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
        </el-card>
    </div>
</template>

<script>
  import axios from "axios";
  import store from "@/store/store";
  import ip from "@/config/ip.js";
    import {
        getRecycleHistoryList, recoveryAdd, recoveryUpdate, recoveryDelete, recyclingExports
    } from "../../api/api";
    import {getPermission} from '../../api/authRequest'
    export default {
        name: 'recoveryProfit',
        components: {},
        data () {
            return {
                canSet:false,
                dialogMenuStatus: "",
                dislogCreate:false,
                labelPosition:'left',
                materForm:{
                    begin: '',
                    end: '',
                    price: '',
                },
                searchForm:{
                    modelName: '',
                    customerPhone: '',
                    createTimeStart: '',
                    createTimeEnd: '',
                },
                returnData: [],
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 30,
                },
                valueTime1:[],
                basicsAuth:{
                    recoveryAdd:false,
                    recoveryUpdate:false
                }
            }
        },
        mounted () {
            this.getMaterialClass()
            // this.basicsAuth.insertMaterialClassification= getPermission('/api/basicSetting/MaterialClassification/insertMaterialClassification');
            // this.basicsAuth.updateMaterialClassification= getPermission('/api/basicSetting/MaterialClassification/updateMaterialClassification');
        },
        methods: {
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getMaterialClass()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getMaterialClass()
            },
            //清空form
            emptyDialog(formName) {
                this.dislogCreate = false
                this.$refs[formName].resetFields();
            },
            ///查询物料分类
            getMaterialClass(){
                let para={
                  modelName:this.searchForm.modelName,
                  customerPhone: this.searchForm.customerPhone,
                  shopAccount: this.searchForm.shopAccount,
                  shopName: this.searchForm.shopName,
                  createTimeStart:this.searchForm.createTimeStart,
                  createTimeEnd:this.searchForm.createTimeEnd,
                  startRow:this.pages.page,
                  pageSize:this.pages.pageSize
                }
                getRecycleHistoryList(para).then(res => {
                    if (res.data.status==100) {
                        this.returnData = res.data.results.list
                        this.pages.total = res.data.results.total;
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
        //     ///导出回收询价信息
        //     getrecyclingExports(){
        //         let para={
        //             modelName:this.searchForm.modelName,
        //             customerPhone:this.searchForm.customerPhone,
        //             createTimeStart:this.searchForm.createTimeStart,
        //             createTimeEnd:this.searchForm.createTimeEnd,
        //             startRow:this.pages.page,
        //             pageSize:this.pages.pageSize
        //         }
        //          const loading = this.$loading({
        //   lock: true,
        //   text: "正在生成文件，请稍等...",
        //   spinner: "el-icon-loading",
        //   background: "rgba(0, 0, 0, 0.7)"
        // });
        // axios({
        //   // url: `${ip.Ips.ip1}/api/export/export_warehouse`,
        //   url: `${ip.Ips.ip1}/recovery/params/recyclingExports`,
        //   method: "post",
        //   headers: {
        //     token: `${store.state.token}`
        //   },
        //   data: para,
        //   responseType: "blob"
        // })
        //   .then(res => {
        //     loading.close();
        //     let fileName = res.headers["content-disposition"].split(";")[1].trim().split('filename=')[1].split('"')[1]
        //     if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //       let blob = new Blob([res.data], {
        //         type: "application/vnd.ms-excel"
        //       });
        //       window.navigator.msSaveOrOpenBlob(blob, fileName);
        //     } else {
        //       let blob = new Blob([res.data], {
        //         type: "application/vnd.ms-excel"
        //       });
        //       const link = document.createElement("a");
        //       link.style.display = "none";
        //       link.href = URL.createObjectURL(blob);
        //       link.setAttribute(
        //         "download",
        //         fileName
        //       );
        //       document.body.appendChild(link);
        //       link.click();
        //       document.body.removeChild(link);
        //     }
        //   })
        //   .catch(error => {
        //     this.$Message.error(error.message);
        //   });
        //     },

 //导出
      getrecyclingExports() {
        // 时间范围为一个月
        if (this.valueTime1 != null && this.valueTime1.length > 1) {
          this.searchForm.createTimeStart = new Date(this.valueTime1[0]);
          this.searchForm.createTimeEnd = new Date(this.valueTime1[1]);
          // 时间范围为一个月
          if (
            this.searchForm.createTimeEnd - this.searchForm.createTimeStart >
            30 * 24 * 60 * 60 * 1000
          ) {
            this.$Message.error("时间范围不能超过一个月");
            return;
          }
        } else {
          this.$Message.error("请选择时间范围");
          return
        }
       let para={
         modelName: this.searchForm.modelName,
         customerPhone: this.searchForm.customerPhone,
         shopAccount: this.searchForm.shopAccount,
         shopName: this.searchForm.shopName,
         createTimeStart: this.searchForm.createTimeStart,
         createTimeEnd: this.searchForm.createTimeEnd,
         startRow: this.pages.page,
         pageSize: this.pages.pageSize
        }
        const loading = this.$loading({
          lock: true,
          text: "正在生成文件，请稍等111...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        axios({
          url: `${ip.Ips.ip1}/recovery/params/recyclingExports`,
          method: "post",
          headers: {
            token: `${store.state.token}`
          },
          data: para,
          responseType: "blob"
        })
          .then(res => {
          // recyclingExports(para).then(res => {
            loading.close();
            let fileName = res.headers["content-disposition"].split(";")[1].trim().split('filename=')[1].split('"')[1]
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              let blob = new Blob([res.data], {
                type: "application/vnd.ms-excel"
              });
              window.navigator.msSaveOrOpenBlob(blob, fileName);
            } else {
              let blob = new Blob([res.data], {
                type: "application/vnd.ms-excel"
              });
              const link = document.createElement("a");
              link.style.display = "none";
              link.href = URL.createObjectURL(blob);
              link.setAttribute(
                "download",
                fileName
              );
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          })
          .catch(error => {
            this.$Message.error(error.message);
          });
      },

            //清空刷新
            refresh() {
                this.getMaterialClass()
            },
            //确认检索
            SubmitSearch() {
              if(this.valueTime1 != null && this.valueTime1.length > 1 ){
                    this.searchForm.createTimeStart = new Date(this.valueTime1[0])
                    this.searchForm.createTimeEnd = new Date(this.valueTime1[1])
                }else{
                    this.searchForm.createTimeStart = "";
                    this.searchForm.createTimeEnd = "";
                }
                this.getMaterialClass()
            },
            //导出数据
            exportRecyclingList() {
              if(this.valueTime1 != null && this.valueTime1.length > 1 ){
                    this.searchForm.createTimeStart = new Date(this.valueTime1[0])
                    this.searchForm.createTimeEnd = new Date(this.valueTime1[1])
                }else{
                    this.searchForm.createTimeStart = "";
                    this.searchForm.createTimeEnd = "";
                }
                this.getrecyclingExports()
            },
            clearFrom(){
                this.searchForm = {}
            }
        },
        computed: {},
        watch: {}
    }
</script>



// WEBPACK FOOTER //
// recoveryParams.vue?3631aa73